import { NgModule } from '@angular/core';

import { AppComponent } from './_modules/app/app.component';
import { NavMenuComponent } from './_modules/navmenu/navmenu.component';
import { NavmenuDropdownComponent } from './_modules/navmenu/navmenu-dropdown/navmenu-dropdown.component';
import { CustomSelectComponent } from './_modules/customselect/customselect.component';
import { MetasSortPipe } from './_pipes/categorias-metas.pipe';
import { CustomItemComponent } from './_modules/customselect/item-customselect.component';
import { UserMenuComponent } from './user/user-menu/user-menu.component';
import { NotfoundComponent } from './notfound.component';
import { ThrobberComponent } from './_directives/throbber/throbber.component';
import { AppRoutingModule } from './app-routing.module';
// import { SortablejsModule } from 'ngx-sortablejs';
import { GoogleApiModule, NgGapiClientConfig, NG_GAPI_CONFIG } from 'ng-gapi';
import { StoreModule } from '@ngrx/store';
import { environment } from 'src/environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

const gapiClientConfig: NgGapiClientConfig = {
  client_id: `748787902858-v7tp7lh1h650j9uknh2fpiqm8jilf8gm.apps.googleusercontent.com`,
  discoveryDocs: ['https://analyticsreporting.googleapis.com/$discovery/rest?version=v4'],
  scope: [
    'https://www.googleapis.com/auth/drive',
    'https://www.googleapis.com/auth/drive.readonly',
    'https://www.googleapis.com/auth/spreadsheets',
    'https://www.googleapis.com/auth/drive',
    'https://www.googleapis.com/auth/spreadsheets.readonly'
  ].join(' ')
};

export const sharedConfig: NgModule = {
  declarations: [
    AppComponent,
    NavMenuComponent,
    NavmenuDropdownComponent,
    MetasSortPipe,
    CustomSelectComponent,
    CustomItemComponent,
    UserMenuComponent,
    NotfoundComponent,
    ThrobberComponent,

  ],
  imports: [

    // SortablejsModule.forRoot({ 
    //   animation: 150 
    // }),
    // GoogleApiModule.forRoot({
    //   provide: NG_GAPI_CONFIG,
    //   useValue: gapiClientConfig
    // }),

    AppRoutingModule,
    StoreModule.forRoot({}),
    StoreDevtoolsModule.instrument({
      name: 'MiGLM App DevTools',
      maxAge: 25,
      logOnly: environment.production
    }),
    EffectsModule.forRoot([])
  ],
  bootstrap: [
    AppComponent
  ],
};
